import React, {useState} from 'react'
import PropTypes from 'prop-types'
import _ from "lodash"
import {Collapse} from 'reactstrap'

import DragWrapper from "./DragWrapper"
import InputContainer from "@src/components/helpers/InputContainer"
import CustomFormGroup from "@src/components/helpers/CustomFormGroup"

const Text = props => {
  const {data} = props
  const [currentData, setCurrentData] = useState(data)

  return (
    <></>
  )
}

Text.propTypes = {}

export default Text